<template>
    <div class="tco-tool__popout-grid-engines">
        <label class="tco-tool__popout-label">Choose your engine</label>
        <p v-if="!selectedModel || !selectedTrim">Please choose a trim first</p>
        <div v-else class="tco-tool__select-model-outer">
            <button @click="showSelectVehicle = !showSelectVehicle" type="button"
                class="btn btn--blue-inverted btn--full-width tco-tool__select-model-label">
                <span v-if="selectedVehicle">{{ selectedVehicle.version }}</span>
                <span v-else>Choose your engine</span>
                <img src="/images/new/details/down-arrow.svg" alt="" class="tco-tool__select-model-arrow"
                    :class="{'tco-tool__select-model-arrow--selected': showSelectVehicle}" />
            </button>
            <div v-show="showSelectVehicle" class="tco-tool__select-model-container" ref="show-select-model"
                @focusout="showSelectVehicle = false">
                <button class="tco-tool__select-model-btn"
                    :class="{'tco-tool__select-model-btn--selected': selectedVehicle && option.id == selectedVehicle.id}"
                    @click="selectVehicleAndClose(option)" v-for="option in availableVehicles"
                    :key="'selectModel.' + option.id">{{ option.version }}</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import { customEvent } from '../../../../modules/tracking/AnalyticsEvents';

export default {
    props: {
        isElectric: {
            required: false,
            default: false,
        }
    },
    data() {
        return {
            showSelectVehicle: false,
        };
    },
    methods: {
        ...mapMutations(['setSelectedEvVehicle', 'setSelectedIceVehicle']),
        selectVehicle(vehicle, isUserInteraction = true) {
            if (this.isElectric) {
                if (isUserInteraction) {
                    customEvent('TCO', 'Clicked', 'Step 2.3 - ' + vehicle.brand + ' ' + this.selectedModel.electric_model_title + ' ' + this.selectedTrim.trim + ' ' + vehicle.version);
                }
                return this.setSelectedEvVehicle(vehicle);
            }
            if (isUserInteraction) {
                customEvent('TCO', 'Clicked', 'Step 3.3 - ' + vehicle.brand + ' ' + this.selectedModel.short_name + ' ' + this.selectedTrim.trim + ' ' + vehicle.version);
            }
            return this.setSelectedIceVehicle(vehicle);
        },
        selectVehicleAndClose(vehicle) {
            this.selectVehicle(vehicle, true);
            this.showSelectVehicle = false;
        }
    },
    computed: {
        ...mapState([
            'selectedEvModel',
            'selectedIceModel',
            'selectedEvTrim',
            'selectedIceTrim',
            'selectedEvTrim',
            'selectedIceTrim',
            'selectedEvVehicle',
            'selectedIceVehicle',
        ]),
        selectedModel() {
            if (this.isElectric) {
                return this.selectedEvModel;
            }
            return this.selectedIceModel;
        },
        selectedTrim() {
            if (this.isElectric) {
                return this.selectedEvTrim;
            }
            return this.selectedIceTrim;
        },
        selectedVehicle() {
            if (this.isElectric) {
                return this.selectedEvVehicle;
            }
            return this.selectedIceVehicle;
        },
        availableVehicles() {
            if (!this.selectedModel) {
                return [];
            }
            if (!this.selectedTrim) {
                return [];
            }
            const newVehiclesLength = this.selectedModel.new_vehicles.length;
            if (newVehiclesLength == 0) {
                return false;
            }

            const availableVehicles = [];
            for (let index = 0; index < newVehiclesLength; index++) {
                const newVehicle = this.selectedModel.new_vehicles[index];
                if (newVehicle.new_vehicles_trim_id != this.selectedTrim.id) {
                    continue;
                }
                const fuel = newVehicle.fuel_type.toLowerCase();
                if (this.isElectric) {
                    if (!fuel.includes('electric')) {
                        continue;
                    }
                    availableVehicles.push(newVehicle);
                    continue;
                }

                if (fuel.includes('electric')) {
                    continue;
                }

                availableVehicles.push(newVehicle);
            }
            if (!this.selectedVehicle && typeof availableVehicles[0] != 'undefined') {
                this.selectVehicle(availableVehicles[0], false);
            }
            return availableVehicles;
        }
    },
}
</script>